import { DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useModal } from 'components/Modals';
import VirtualDrop from 'components/VirtualDrop';
import InputMask from 'components/InputMask';
import Button from 'components/Button';
import Input from 'components/Input';

const ConfigModal = ({ control, drops, filtros, loading, onFilter }) => {
  const { closeModal } = useModal();

  return (
    <>
      <DialogTitle>Configurações do Cálculo</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          {filtros?.map((input, i) => {
            const field = input?.field || '';
            const label = input?.label || '';
            const options = input?.optionsEval
              ? eval(input?.optionsEval)
              : typeof input?.options === 'string'
                ? drops[input?.options]
                : input?.options;

            const setRender = () => {
              switch (input?.type) {
                case 'date':
                  return (
                    <InputMask
                      name={field}
                      control={control}
                      label={label}
                      type="date"
                    />
                  );
                case 'number':
                  return (
                    <InputMask name={field} control={control} label={label} />
                  );
                case 'string':
                  return <Input name={field} control={control} label={label} />;
                case 'drop':
                  return (
                    <VirtualDrop
                      name={field}
                      control={control}
                      label={label}
                      options={options}
                    />
                  );
                default:
                  return null;
              }
            };

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={i?.toString()}>
                {setRender()}
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={closeModal}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={onFilter} loading={loading}>
          Calcular Necessidade
        </Button>
      </DialogActions>
    </>
  );
};

export default ConfigModal;
